module.exports = __webpack_public_path__ + "img/金属材料学3_7.fa399b24.png";